import { createFileRoute } from '@tanstack/react-router';
import AppointmentSettingsPage from '@/pages/setup/AppointmentSettingsPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export const Route = createFileRoute('/_authenticated/setup/appointment-types')({
  beforeLoad: () => requireSetupPageAccess('/setup/appointment-types'),
  component: AppointmentSettingsPage,
});
